import { api } from "@/api";
const wagesStore = {
  state: {
    payTotalCost: []
  },
  getters: {
    getPayTotalCost(state) {
      return state.payTotalCost;
    },
    getPayTotalCostById(state) {
      return id => {
        return state.payTotalCost.filter(i => i.id !== id);
      };
    }
  },
  mutations: {
    setPayTotalCost(state, value) {
      state.payTotalCost = value;
    },
    addPayTotalCost(state, value) {
      state.payTotalCost.push(value);
    },
    updatePayTotalCost(state, value) {
      state.payTotalCost = state.payTotalCost.filter(i => i.id !== value.id);
      state.payTotalCost.push(value);
    },
    deletePayTotalCost(state, value) {
      state.payTotalCost = state.payTotalCost.filter(i => i.id !== value.id);
    }
  },
  actions: {
    async loadPayTotalCost({ commit }) {
      const res = await api.getPayCosts();
      commit("setPayTotalCost", res);
    },
    async addPayTotalCost({ commit }, item) {
      const res = await api.postPayCost(item);
      commit("addPayTotalCost", res);
    },
    async updatePayTotalCost({ commit }, item) {
      const res = await api.putPayCost(item.id, item);
      commit("updatePayTotalCost", res);
    },
    async deletePayTotalCost({ commit }, item) {
      await api.deeletePayCost(item.id);
      commit("deletePayTotalCost", item);
    }
  }
};

export default wagesStore;
